import React, {useEffect} from 'react';
import { styled } from '@mui/material/styles';
import {useViewport} from '../../../../helpers';
import {useTranslation} from 'react-i18next';
import {
  Button,
  Divider,
} from "@mui/material";
import { TextField, Typography } from '@mui/material';
import clsx from 'clsx';

const PREFIX = 'Password';

const classes = {
  fullWidthElement: `${PREFIX}-fullWidthElement`,
  paddingRoot: `${PREFIX}-paddingRoot`,
  inputSize: `${PREFIX}-inputSize`,
  title: `${PREFIX}-title`,
  subTitle: `${PREFIX}-subTitle`,
  contentContainer: `${PREFIX}-contentContainer`,
  buttonContainer: `${PREFIX}-buttonContainer`,
  actionButton: `${PREFIX}-actionButton`,
  buttonsContainer: `${PREFIX}-buttonsContainer`,
  marginTop: `${PREFIX}-marginTop`,
  divider: `${PREFIX}-divider`
};

const Root = styled('div')((
  {
    theme
  }
) => ({
  [`& .${classes.fullWidthElement}`]: {
    width: '100%',
    textAlign: 'center',
    paddingTop: '1rem',
  },

  [`& .${classes.paddingRoot}`]: {
    padding: '1rem',
  },

  [`& .${classes.inputSize}`]: {
  },

  [`& .${classes.title}`]: {
    marginBottom: '0.5rem !important',
  },

  [`& .${classes.subTitle}`]: {
    marginBottom: '1.5rem !important'
  },

  [`& .${classes.contentContainer}`]: {
    [theme.breakpoints.up('sm')]: {
      width: '80%',
    },
    margin: '0 auto'
  },

  [`& .${classes.buttonContainer}`]: {
    display: 'flex',
    justifyContent: 'end',
    [theme.breakpoints.up('sm')]: {
      width: '90%',
    },
  },

  [`& .${classes.actionButton}`]: {
    float: 'right',
  },

  [`& .${classes.buttonsContainer}`]: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around'
  },

  [`& .${classes.marginTop}`]: {
    marginTop: '1rem'
  },

  [`& .${classes.divider}`]: {
    // marginTop: '2rem',
    // marginBottom: '2rem',
  }
}));

const Password = (props) => {

  const {width} = useViewport();
  const {t, i18n} = useTranslation();

  useEffect(() => {
    if (!props.exparience.securedByPassword || (props.exparience.securedByPassword && (props.exparience.password && props.exparience.password.length > 0)))
      props.setIsValid(true);
    else
      props.setIsValid(false);
  }, [props.exparience.securedByPassword, props.exparience.password])

  if (props.currentStep >= 4) {
    return (
      <Root>
        <div className={clsx(classes.fullWidthElement, classes.paddingRoot)}>
          <Typography variant="h5" className={classes.title}>{t('exparienceCreateForm.securePasswordTitle')}</Typography>
          <Typography variant="body2"className={classes.subTitle}>{t('exparienceCreateForm.securePasswordSubTitle')}</Typography>
          <div className={classes.contentContainer}>
            <div className={classes.buttonsContainer}>
              <Button
                variant="contained"
                color="primary"
                onClick={e => props.handleChangeField('securedByPassword', true)}
                style={{
                  border: props.exparience.securedByPassword && '1px solid white',
                  opacity: props.exparience.securedByPassword === false && '0.5',
                }}
              >
                {t('exparienceCreateForm.yes')}
              </Button>
              <Button
                variant="contained"
                color="primary"
                style={{
                  border: props.exparience.securedByPassword === false && '1px solid white',
                  opacity: props.exparience.securedByPassword && '0.5',
                }}
                onClick={e => {
                  e.stopPropagation();
                  props.handleChangeField('securedByPassword', false);
                  props.handleNextStep(5);
                }}
              >
                {t('exparienceCreateForm.no')}
              </Button>
            </div>
            {props.exparience.securedByPassword &&
              <div className={classes.marginTop}>
                <TextField
                  name="descriptionApp"
                  label={t('myExpariences.form.password')}
                  className={clsx(width > 1024 ? classes.maxInputSize : "")}
                  onChange={e => props.handleChangeField('password', e.target.value)}
                  value={props.exparience.password}
                  fullWidth
                  variant={"outlined"}
                />
              </div>
            }
          </div>
          {props.currentStep === 4 && props.exparience.securedByPassword &&
            <div className={clsx(classes.buttonContainer, classes.marginTop)}>
              <Button
                variant="contained"
                color="primary"
                disabled={props.exparience.password.length === 0}
                onClick={e => props.handleNextStep(5)}
                className={classes.actionButton}
              >
                {t('exparienceCreateForm.continueButton')}
              </Button>
            </div>
          }
        </div>
        <Divider light className={classes.divider}/>
      </Root>
    );
  } else {
    return null;
  }
}

export default Password;